module.exports = __webpack_public_path__ + "assets/img/00030.117b1e5c.png";